import React from "react";
import Modal from "./Modal";
import AdjustmentEditor from "../editors/AdjustmentEditor";

const AdjustmentModal = ({
  open,
  onClose,
  onSave,
  adjustment,
  users,
  projects,
  adjustmentTypes,
  payPeriodId,
  currentUserId,
}) => {
  return (
    <Modal
      title={adjustment ? "Edit Adjustment" : "Add Adjustment"}
      open={open}
      onClose={onClose}
      width="500px"
      height="550px"
    >
      <AdjustmentEditor
        adjustment={adjustment}
        users={users}
        projects={projects}
        adjustmentTypes={adjustmentTypes}
        payPeriodId={payPeriodId}
        currentUserId={currentUserId}
        onSave={onSave}
        onClose={onClose}
      />
    </Modal>
  );
};

export default AdjustmentModal;
